export {default} from './Tab.vue';

